/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-use-before-define */
/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */

import { AxiosResponse } from 'axios';
import { path } from 'rambda';
import { MultiTransactionItemInterface } from '@/interfaces/transactionsTypes';
import { defineModule } from 'direct-vuex';
import { modActionCtx, modGetterCtx } from '@/store/index';
import { api } from '@/utils/apiInstance';

import {
  FetchStateInterface,
  getFetchState,
  getFetchMutations,
  basicAdapterFetch,
} from '@/store/storeUtils';
import { INIT, PENDING } from '@/utils/statuses';
import getAuth from '@/utils/cookies/getAuth';

export type MultitransactionResponse = AxiosResponse<{ data: MultiTransactionItemInterface }>;

const multitransactionsStore = defineModule({
  namespaced: true,
  state: {
    ...getFetchState<MultitransactionResponse>(),
  } as FetchStateInterface<MultitransactionResponse>,

  getters: {
    data(...args): MultiTransactionItemInterface[] | undefined {
      const { state } = getterCtx(args);

      const result = path('data.data', state.response) as MultiTransactionItemInterface[];

      return result;
    },
  },
  mutations: {
    ...getFetchMutations(),
    SET_INIT(state) {
      state.fetchState = INIT;
    },
  },
  actions: {
    async fetch(ctx) {
      const { commit, state } = actionCtx(ctx);

      if (state.fetchState === PENDING) {
        return;
      }

      await basicAdapterFetch({
        method: api.adapter.sendPost,
        props: {
          url: '/transactions',
          data: {
            drivers: {
              oton: {
                token: getAuth(),
              },
            },
          },
        },
        setState: commit.SET_STATE,
        // update state
        callback: () => {
          // console.info({ fetchState });
        },
      });
    },
  },
});

export default multitransactionsStore;
const getterCtx = (args: [any, any, any, any]) => modGetterCtx(args, multitransactionsStore);
const actionCtx = (ctx: any) => modActionCtx(ctx, multitransactionsStore);
